import { Stack, Typography } from '@mui/material'
import React from 'react'
import { com } from '@eidu/web'
import KindInput from '../input/KindInput'
import LabelDisplay from './LabelDisplay'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import FieldDisplay from './FieldDisplay'

type FieldsStackProps = {
  entityType: EntityType
  entityTypes: readonly EntityType[]
}

const FieldsStack = ({ entityType, entityTypes }: FieldsStackProps) => {
  const fields = entityType.fields.asJsReadonlyArrayView()

  const primaryLabel = entityType.label.primary
  const secondaryLabel = entityType.label.secondary || undefined

  return (
    <Stack spacing={3}>
      {fields.length > 0 && (
        <>
          <Typography variant="h5">Kind</Typography>
          <KindInput kind={entityType.kind} />
        </>
      )}

      {fields.length > 0 && <Typography variant="h5">Fields</Typography>}
      {fields.map((field) => (
        <Stack key={field.id.toString()}>
          <FieldDisplay availableEntityTypes={entityTypes} field={field} />
        </Stack>
      ))}
      {fields.length > 0 && (
        <LabelDisplay fields={fields} primaryLabel={primaryLabel} secondaryLabel={secondaryLabel} />
      )}
    </Stack>
  )
}

export default FieldsStack
